import { render } from "./Combobox.vue?vue&type=template&id=5fc66342&scoped=true"
import script from "./Combobox.vue?vue&type=script&lang=js"
export * from "./Combobox.vue?vue&type=script&lang=js"

import "./Combobox.vue?vue&type=style&index=0&id=5fc66342&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc66342"]])

export default __exports__